import { isEmpty } from "lodash";
import { useState } from "react";
import { getComplexReason } from "../utils/getComplexReason";

export const useChangeStatusWithReason = (
  value: string,
  reason: string | null,
  otherReason: string,
  changeStatusResult: (
    action: string,
    additional?: {
      reason?: string;
      message?: string;
    }
  ) => void
): [() => void, any, React.Dispatch<any>] => {
  const [validationErrors, setValidationErrors] = useState<any>({});

  const request = () => {
    const errors: { [key: string]: boolean } = {};
    if (reason !== null && !reason) {
      errors.reason = true;
    }
    if (reason === "Other" && !otherReason) {
      errors.otherReason = true;
    }

    if (isEmpty(errors)) {
      const complexReason = getComplexReason(reason ?? "", otherReason);
      changeStatusResult(value, { reason: complexReason });
    } else {
      setValidationErrors(errors);
    }
  };
  return [request, validationErrors, setValidationErrors];
};
